import React, { Component } from 'react';
import { Button } from 'react-materialize';
import { Link } from "react-router-dom";

import EventUtils from '../../utils/EventUtils';

import defaultThumbnail from '../../images/EmptyPicture.png';
import './ThumbnailCard.css';

class ThumbnailCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected ? props.selected : false
    };
    
    this.handleSelectClick = this.handleSelectClick.bind(this);
  }

  get selected() {
    return this.state.selected;
  }

  set selected(selected) {
    this.setState({ selected: selected }, () => {
      let details = { id: this.props.id, selected: this.selected };
      EventUtils.raiseEvent('select', details, this.props);
    });
  }

  handleSelectClick(event) {
    this.selected = !this.selected;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.selected !== this.props.selected && props.selected !== this.selected) {
      this.selected = props.selected;
    }
  }

  render() {
    const { selected } = this.state;
    const { href, thumbnail, text, actions, showSelectButton, data } = this.props;

    let actionsContainer = () => {
      if (actions) {
        return (
          <div className="action-btn-container">
            {
              Object.keys(actions)
                .map((actionName, id) => {
                  let action = actions[actionName];
                  let checked = action.isChecked(data);
                  return (<Button floating key={id} className={ checked ? 'action-btn checked' : 'action-btn' } waves="light" icon={ action.icon } tooltip={ action.name } onClick={ (event) => {
                    if (!action.clickHandler) {
                      return;
                    }
                    
                    event.detail = { data: data };
                    action.clickHandler(event);
                  } } />);
                })
            }
          </div>
        );
      } else {
        return (<div/>);
      }
    }

    return (
      <div className={ selected ? 'thumbnail-card selected' : 'thumbnail-card' }>
        <div className="select-btn-container" hidden={ !showSelectButton && !selected }>
          <Button floating className="select-btn" waves="light" icon="check" onClick={ this.handleSelectClick } />
        </div>
        { actionsContainer() }
        <Link to={ href ? href : '#' }>
          <div className="thumbnail" style={ { backgroundImage: thumbnail ? `url(${thumbnail})` : `url(${defaultThumbnail})` } }></div>
        </Link>
        <Link to={ href ? href : '#' } className="title">
          <div className="title">{ text }</div>
        </Link>
      </div>
    );
  }
}

export default ThumbnailCard;
